function getProductLoadMoreRoot(button) {
  const root =
    button?.closest('#ProductGridContainer') ||
    document.getElementById('ProductGridContainer');
  return root || null;
}

function getProductLoadMoreGrid(root) {
  if (!root) return null;
  return root.querySelector('ul#product-grid.collection-product-list') ||
    root.querySelector('#product-grid') ||
    root.querySelector('.load-more-grid');
}

function getSearchLoadMoreContext(button, root) {
  return (
    button?.closest('.collection-product') ||
    root?.querySelector('.collection-product:not(.collection--empty)') ||
    root
  );
}

function getProductGridChunkFromHtml(responseHTML) {
  const doc = new DOMParser().parseFromString(responseHTML, 'text/html');
  const grid = doc.querySelector('#ProductGridContainer #product-grid, #product-grid');
  if (grid) {
    const items = grid.querySelectorAll(':scope > li');
    if (items.length) {
      return [...items].map((li) => li.outerHTML).join('');
    }
  }
  const $ = window.jQuery;
  if (!$) return '';
  const parsed = $(responseHTML);
  const fromContainer = parsed.find('#ProductGridContainer #product-grid').first();
  if (fromContainer.length) {
    return fromContainer.children('li').toArray().map((el) => el.outerHTML).join('');
  }
  const productGrid = parsed.find('#product-grid').first();
  if (productGrid.length) {
    return productGrid.children('li').toArray().map((el) => el.outerHTML).join('');
  }
  return '';
}

function isClistProductsLoadMoreButton(button) {
  return Boolean(button?.closest('[data-clist-products-inner]'));
}

function isSearchPageLoadMoreRoot(root) {
  const section = root?.closest('[id^="shopify-section-"]');
  return Boolean(section?.querySelector('.template-search'));
}

function buildSearchLoadMoreUrl(value, pageValue) {
  const url = new URL(value || window.location.href, window.location.origin);
  url.searchParams.set('page', String(pageValue));
  url.searchParams.delete('phcursor');
  url.searchParams.set('type', 'product');
  if (!url.searchParams.has('options[prefix]')) {
    url.searchParams.set('options[prefix]', 'last');
  }
  return url.pathname + '?' + url.searchParams.toString();
}

function syncSearchLoadMorePaginationFromHtml(root, context, responseHTML) {
  if (!root || !context || !responseHTML) return;
  const doc = new DOMParser().parseFromString(responseHTML, 'text/html');
  const fresh = doc.getElementById('ProductGridContainer');
  if (!fresh) return;

  const freshContext =
    fresh.querySelector('.collection-product:not(.collection--empty)') || fresh;

  ['data-total-pages', 'data-current-page', 'data-next-url'].forEach((attr) => {
    const dst = context.querySelector(`input[${attr}]`);
    if (!dst) return;
    const src = freshContext.querySelector(`input[${attr}]`);
    dst.value = src ? src.value : '';
  });
}

function getSearchLoadMoreBatchSize(root) {
  return parseInt(root.querySelector('[data-search-batch-size]')?.value, 10) || 20;
}

function getSearchLoadMoreTotalProducts(root) {
  const section = root.closest('[id^="shopify-section-"]');
  const fromSpan = parseInt(section?.querySelector('#search-total-products')?.getAttribute('data-total'), 10);
  if (fromSpan > 0) return fromSpan;
  return parseInt(root.querySelector('[data-search-total-products]')?.value, 10) || 0;
}

function countSearchProductCards(root) {
  const grid = getProductLoadMoreGrid(root);
  if (!grid || grid.classList.contains('collection--empty')) return 0;
  return grid.querySelectorAll(':scope > li.collection-grid-card, :scope > li').length;
}

function removeSearchLoadMoreUI(root) {
  if (!root) return;
  const loaded = countSearchProductCards(root);
  const section = root.closest('[id^="shopify-section-"]');
  const totalSpan = section?.querySelector('#search-total-products');
  const totalInput = root.querySelector('[data-search-total-products]');

  if (loaded > 0) {
    if (totalSpan) totalSpan.setAttribute('data-total', String(loaded));
    if (totalInput) totalInput.value = String(loaded);
  }

  root.setAttribute('data-search-load-more-done', 'true');

  root.querySelectorAll('[data-search-load-more]').forEach((block) => block.remove());

  root.querySelectorAll('.collection-product > .button-wrapper').forEach((wrapper) => {
    if (wrapper.querySelector('.js-load-more')) wrapper.remove();
  });

  root.querySelectorAll('.collection-product > input[data-next-url]').forEach((input) => input.remove());
}

function checkSearchLoadMoreComplete(root, responseHTML, addedCount) {
  if (!root || !isSearchPageLoadMoreRoot(root)) return false;
  if (root.getAttribute('data-search-load-more-done') === 'true') return true;

  const batchSize = getSearchLoadMoreBatchSize(root);
  const totalProducts = getSearchLoadMoreTotalProducts(root);
  const loaded = countSearchProductCards(root);
  const context = root.querySelector('.collection-product:not(.collection--empty)') || root;
  const totalPages = parseInt(context.querySelector('input[data-total-pages]')?.value, 10) || 0;
  const currentPage = parseInt(context.querySelector('input[data-current-page]')?.value, 10) || 1;
  const nextUrl = (context.querySelector('input[data-next-url]')?.value || '').trim();

  let hide = false;

  if (typeof addedCount === 'number') {
    if (addedCount > 0 && addedCount < batchSize) hide = true;
  }

  if (totalProducts > 0 && loaded >= totalProducts) hide = true;
  if (totalPages > 0 && currentPage >= totalPages) hide = true;
  if (!nextUrl && currentPage > 1) hide = true;

  if (responseHTML) {
    const doc = new DOMParser().parseFromString(responseHTML, 'text/html');
    const fresh = doc.getElementById('ProductGridContainer');
    if (fresh) {
      const freshContext =
        fresh.querySelector('.collection-product:not(.collection--empty)') || fresh;
      const freshBtn = freshContext.querySelector('.js-load-more');
      const freshNext = (freshContext.querySelector('input[data-next-url]')?.value || '').trim();
      const freshGrid = freshContext.querySelector('ul#product-grid, #product-grid');
      const fetchedCount = freshGrid
        ? freshGrid.querySelectorAll(':scope > li.collection-grid-card, :scope > li').length
        : 0;

      if (!freshBtn || !freshNext) hide = true;
      if (fetchedCount > 0 && fetchedCount < batchSize) hide = true;
    }
  }

  if (hide) {
    removeSearchLoadMoreUI(root);
    return true;
  }

  return false;
}

window.SearchLoadMore = {
  checkAndHide(root, responseHTML, addedCount) {
    const container =
      root ||
      document.querySelector('.template-search #ProductGridContainer') ||
      document.getElementById('ProductGridContainer');
    if (container && isSearchPageLoadMoreRoot(container)) {
      return checkSearchLoadMoreComplete(container, responseHTML, addedCount);
    }
    return false;
  },
};

function buildClistProductsPageUrl(rawValue, pageValue) {
  const cfg = window.__clistProductsConfig;
  const basePath = (cfg && cfg.productsFetchPath) || '/collections/all';
  const url = new URL(rawValue, window.location.origin);
  if (!url.pathname.includes('/collections/')) {
    url.pathname = new URL(basePath, window.location.origin).pathname;
  }
  url.searchParams.set('page', String(pageValue));
  url.searchParams.delete('phcursor');
  url.searchParams.delete('view');
  return url.pathname + url.search;
}

const loadItems = (button) => {
  const root = getProductLoadMoreRoot(button);
  if (!root) return;

  const context = getSearchLoadMoreContext(button, root);
  const totalPagesInput = context.querySelector('input[data-total-pages]');
  const currentPageInput = context.querySelector('input[data-current-page]');
  const nextUrlInput = context.querySelector('input[data-next-url]');
  const grid = getProductLoadMoreGrid(root);

  if (!totalPagesInput || !currentPageInput || !nextUrlInput || !grid) return;

  const totalPages = parseInt(totalPagesInput.value, 10);
  let currentPage = parseInt(currentPageInput.value, 10);
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const rawValue = nextUrlInput.value || window.location.href;
  const isSearch = isSearchPageLoadMoreRoot(root);

  const getUrlWithoutPhcursor = (value, pageValue) => {
    if (isSearch) return buildSearchLoadMoreUrl(value, pageValue);
    const url = new URL(value, window.location.origin);
    url.searchParams.set('page', pageValue);
    url.searchParams.delete('phcursor');
    return url.pathname + '?' + url.searchParams.toString();
  };

  const nextUrl = isClistProductsLoadMoreButton(button)
    ? buildClistProductsPageUrl(rawValue, currentPage)
    : getUrlWithoutPhcursor(rawValue, currentPage);
  const nextUrlScroll = isClistProductsLoadMoreButton(button)
    ? buildClistProductsPageUrl(rawValue, currentPageScroll)
    : getUrlWithoutPhcursor(rawValue, currentPageScroll);
  currentPageInput.value = currentPage;

  button.setAttribute('disabled', '');
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      const currentScrollTop = $(window).scrollTop();
      const chunk = getProductGridChunkFromHtml(responseHTML);
      if (chunk) {
        grid.insertAdjacentHTML('beforeend', chunk);
      }

      if (isSearch) {
        syncSearchLoadMorePaginationFromHtml(root, context, responseHTML);
        const section = root.closest('[id^="shopify-section-"]');
        if (section) {
          section.dispatchEvent(
            new CustomEvent('search:load-more-complete', {
              detail: { responseHTML: responseHTML },
            })
          );
        }
      }

      colorSwatches();
      $(window).scrollTop(currentScrollTop);
      const scope = root.closest('[id^="shopify-section-"]');
      window.ClistMobileGridBorders?.scheduleUpdate?.(scope || document);
      if (
        window.ClistProductsPlp &&
        typeof window.ClistProductsPlp.syncProductsToolbarCountFromDom === 'function'
      ) {
        window.ClistProductsPlp.syncProductsToolbarCountFromDom();
      }
    },
    complete: function () {
      if (isSearch) {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        return;
      }

      if (currentPage <= totalPages) {
        const scollData = root.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          const nextInput = scollData.querySelector('input[data-next-url]');
          const pageInput = scollData.querySelector('input[data-current-page]');
          if (nextInput) {
            nextInput.dataset.nextUrl = nextUrlScroll;
            nextInput.value = nextUrlScroll;
          }
          if (pageInput) {
            pageInput.dataset.currentPage = currentPage;
            pageInput.value = currentPage;
          }
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    },
  });
};

let infiniteScrollObservers = [];

const checkVisibility = () => {
  infiniteScrollObservers.forEach((observer) => observer.disconnect());
  infiniteScrollObservers = [];

  const productGrid = document.getElementById('ProductGridContainer');
  if (!productGrid) return;

  const spinnerList = productGrid.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
    infiniteScrollObservers.push(sectionObserver);
  });
};

function loadMore() {
  document.querySelectorAll('#ProductGridContainer .js-load-more').forEach((button) => {
    if (isClistProductsLoadMoreButton(button)) return;
    button.onclick = () => {
      loadItems(button);
    };
  });

  if (
    window.ClistProductsPlp &&
    typeof window.ClistProductsPlp.wireProductsLoadMore === 'function'
  ) {
    window.ClistProductsPlp.wireProductsLoadMore();
  }

  checkVisibility();
}

(function () {
  loadMore();
})();
